<template>
    <div class="dormitory-front">
        <lead :headOption="headOption"/>
        <div class="dormitory-manage" v-if="managerole" @click="goManage">宿舍管理</div>
        <main class="main">
            <router-view />
        </main>
        <foote />
    </div>
</template>
<script>
import lead from "@/components/common/head";
import foote from "@/components/common/footer";

export default {
    components: {
        lead,
        foote
    },
    data() {
        return {
            // 顶部模块标题：
            headOption: {
                link: "/dormitory",
                title: "宿舍管理"
            },
            managerole: false,
        }
    },
    created() {
        this.checkLogin();
    },
    methods: {
        goManage() {
            let url = sessionStorage.getItem('manage_url');
            let host = sessionStorage.getItem('host');
            let token = sessionStorage.getItem('redirect_params');

            window.open(decodeURIComponent(url + '/admin' + token + '&host=' + host + '&routerUrl=' + '/life/dormitory/accommodation-registration')); 
        },
        checkLogin() {
            let success = res => {
                if (!is_empty(res.data)) {
                    this.managerole = true;
                } else {
                    this.managerole = false;
                }
            };
            let fail = (res => {})

            this.$ajax({
                url: "api/dormitory/checkDormitoryRoleByUser",
                method: "get",
                params: {user_id: this.$g.user_id},
                func: {
                    success: success,
                    fail: fail
                }
            });
        }
    },
};
</script>     

<style lang="scss">
    .dormitory-front .dormitory-manage {
        position: absolute;
        right: 28px;
        top: 22px;
        width: 124px;
        height: 36px;
        background: #348EFC;
        border-radius: 3px;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 36px;
        text-align: center;
        cursor: pointer;
    }
</style>